import React, { Component } from 'react';
import { Button, Image, Form, Modal, Col, Row, FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import QRImage from '../../../Images/qr-code.svg';
import CopyClip from '../../../Images/copy-clip.png';
import Search from '../../../Images/search-blue.svg';
import Backend from '../../../Backend';
import { store } from 'react-notifications-component';
import SendImage from '../../../Images/send-button.svg';
import Edit from '../../../Images/edit.svg'
import { QRCode } from 'react-qrcode-logo';
import Connection from '../../../Calls';

import '../../../style-animations.css';

// import CameraImage from '../../../images/camera.svg';

class WalletAddressesCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      aliasValue: this.props.row.label,
      editAliasDisabled:true,
      showModal: false,
      ClipboardText:'Copy to clipboard',
      idTooltip:'',

    }
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  componentWillMount() {
    this.setState({ aliasValue: this.props.row.label })
  }

  handleKeyPressChangeAlias(_idAddress, _address) {
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    if (self.state.aliasValue !== "") {
      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        Backend.ChangeLabelWallets(localStorage.getItem('email'), localStorage.getItem('token'), this.state.aliasValue, _idAddress, idWallet, _address, response.payload.r01, response => {
          if (response.status.code === "0") {
            self.props.walletsPagination(1, 10);
            store.addNotification({
              title: "Success!",
              message: "Alias of address changed successfully",
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            this.setState({editAliasDisabled:true})
          } else {
            store.addNotification({
              title: "Error!",
              message: response.status.description,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            this.setState({editAliasDisabled:true})
          }
        });
      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Alias name can't be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
    }
  }

  handleFocus(event) {
    event.target.select();
  }

  navTransactions(){
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    this.props.redirect.push(
      '/wallets/information/transactions?id=' + idWallet + '&coin=' + this.props.walletsinformation.coin,
      this.props.row.address
    );
  }

  CopyToClipboard(){
    const self=this
    self.setState({ClipboardText:'Copied to clipboard', idTooltip:'tooltip-right fade-in'});
    setTimeout(function(){ self.setState({ idTooltip:' tooltip-right fade-out'}) }, 1000)
    setTimeout(function(){ self.setState({ClipboardText:'Copy to clipboard',idTooltip:''}) }, 2000)
  }

  render() {
    const {row} = this.props;
    let symbol = row && row.net && row.net === "sol" ? "Solana" : null;
    return (
      <tr className="hover-tr-table-wallets-generals" style={{ cursor: "default" }}>
        <th><Image src={require("../../../CryptoIcons/" + this.props.walletsinformation.coin + ".svg")} className="icon-crypto-svg" /></th>
        <th className="text-table-container-addres-information">{this.props.row.address}</th>
        <th>

          <OverlayTrigger
            placement={'right'}
            overlay={
              <Tooltip className={this.state.idTooltip}>
               {this.state.ClipboardText}
              </Tooltip>
            }
          >
            <CopyToClipboard text={this.props.row.address}>
              <button className='copy-wallets-clipboard' onClick={()=>{ this.CopyToClipboard()}}>
                <Image src={CopyClip}/>
              </button>
            </CopyToClipboard>
          </OverlayTrigger>
        </th>
        <th className="text-table-container-addres-information">
          {/* {this.props.row.label} */}
          <div className='wallet-alias' style={{ display: "flex" }}>
            <Form.Control onFocus={this.handleFocus} id={this.props.row.address} type="text" disabled={this.state.editAliasDisabled} value={this.state.aliasValue} onChange={(aliasValue) => { this.setState({ aliasValue: aliasValue.target.value }) }} />
            {
              (this.state.editAliasDisabled)
              ?
              <OverlayTrigger
                placement={'right'}
                overlay={
                  <Tooltip>
                    Edit Alias
                  </Tooltip>
                }
                >
                  <button onClick={() => { this.setState({editAliasDisabled:false}) }} ><Image src={Edit} /></button>
              </OverlayTrigger>
              :
              <OverlayTrigger
                placement={'right'}
                overlay={
                  <Tooltip>
                    Save New Alias
                  </Tooltip>
                }
                >
                  <button onClick={() => { this.handleKeyPressChangeAlias(this.props.row.id_address, this.props.row.address) }}><Image src={SendImage}/></button>
              </OverlayTrigger>
            }
          </div>
        </th>
        <th>
          <OverlayTrigger
            placement={'right'}
            overlay={
              <Tooltip>
                Search Transactions
              </Tooltip>
            }
          >
            <button onClick={()=>{this.navTransactions()}} className='copy-address-clipboard'>
              <Image src={Search}/>
            </button>
          </OverlayTrigger>
        </th>
        <th className="text-table-container-addres-information align-text-right">{symbol}</th>
        <th className="text-table-container-addres-information align-text-right">{this.props.row.deposits_amount}</th>
        <th className="text-table-container-addres-information align-text-right">{this.props.row.created_date}</th>
        <th className="text-table-container-addres-information align-text-center">
          <Button onClick={() => { this.handleShow() }} className="button-view-information-wallet">
            <Image style={{ width: 10 }} src={QRImage} />
          </Button>
        </th>
        {/* Modal del wallet original */}
        {/* <Modal className="modal-signup-resend-email" centered aria-labelledby="contained-modal-title-vcenter" show={this.state.showModal} onHide={() => { this.handleClose() }}>
          <Modal.Body>
            <div className="border-title-separator-container">
              <div className="border-title-separator-container-left">
                <p className="title-container-shadow">Qr Code</p>
              </div>
              <div className="border-title-separator-container-right">
                <p className="subtitle-container-shadow">Scan the QR Code</p>
              </div>
            </div>

            <div className="steps-add-wallet-general">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="qr-style-container-logo">
                  <QRCode
                    bgColor="#242424"
                    fgColor="#F2F7FF"
                    ecLevel="M"
                    style={{ width: 150 }}
                    value={this.props.row.address}
                    logoWidth={70}
                    logoOpacity={0.6}
                    logoImage={require("../../../CryptoIcons/" + this.props.walletsinformation.coin + ".svg")}
                    qrStyle={"dots"}
                  />
                </div>
              </div>
              <div style={{ padding: 30 }}>
                <Form.Group as={Row}>
                  <Form.Label column sm="3" className="label-modal">Address:</Form.Label>
                  <Col sm="9">
                    <p style={{ color: "#BCC3D1", fontSize: 15, marginBottom: 0 }}>{this.props.row.address}</p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="3" className="label-modal">Label:</Form.Label>
                  <Col sm="9">
                    <p style={{ color: "#BCC3D1", fontSize: 15, marginBottom: 0 }}>{this.props.row.label}</p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="3" className="label-modal">Created date:</Form.Label>
                  <Col sm="9">
                    <p style={{ color: "#BCC3D1", fontSize: 15, marginBottom: 0 }}>{this.props.row.created_date}</p>
                  </Col>
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
        </Modal> */}
        {/* Modal del wallet copia */}
        <Modal className="modal-signup-resend-email modal-generate-qr-code" centered aria-labelledby="contained-modal-title-vcenter" show={this.state.showModal} onHide={() => { this.handleClose() }}>
          <Modal.Body>

            <div>
              <div style={{ display: "flex", justifyContent:'center'}}>
                <div className="qr-style-container-logo">
                  {
                    (this.props.walletsinformation.coin == 'xrp')
                    ?<div style={{display:'flex', justifyContent:'space-around'}}>
                      <Col style={{textAlign:'center', marginRight:'2em'}} sm="6">
                        <QRCode
                          bgColor="#FFFFFF"
                          fgColor="#0F4C81"
                          ecLevel="M"
                          style={{ width: 150}}
                          value={this.props.xrpAddress}
                          logoWidth={70}
                          logoOpacity={0.3}
                          logoImage={require("../../../CryptoIcons/" + this.props.walletsinformation.coin + ".svg")}
                          qrStyle={"dots"}
                        />
                        <p class="transactions-text-date" style={{textAlign:'center'}}>Address</p>
                      </Col>
                      <Col style={{textAlign:'center'}} sm="6">
                        <QRCode
                          bgColor="#FFFFFF"
                          fgColor="#0F4C81"
                          ecLevel="M"
                          style={{ width: 150 }}
                          value={this.props.row.address}
                          logoWidth={70}
                          logoOpacity={0.3}
                          logoImage={require("../../../CryptoIcons/" + this.props.walletsinformation.coin + ".svg")}
                          qrStyle={"dots"}
                        />
                        <p class="transactions-text-date" style={{textAlign:'center'}}>Destination Tag</p>
                      </Col>
                    </div>
                    :<QRCode
                      bgColor="#FFFFFF"
                      fgColor="#0F4C81"
                      ecLevel="M"
                      style={{ width: 150 }}
                      value={this.props.row.address}
                      logoWidth={70}
                      logoOpacity={0.6}
                      logoImage={require("../../../CryptoIcons/" + this.props.walletsinformation.coin + ".svg")}
                      qrStyle={"dots"}
                    />
                  }
                </div>
              </div>
              <div className="container-qr-code">
                <div style={{ padding: 30 }}>

                  {
                    (this.props.walletsinformation.coin == 'xrp')?
                    <>
                      <Form.Group as={Row}>
                        <Form.Label column sm="4" className="label-modal">Address:</Form.Label>
                        <Col sm="8">
                            <FormControl
                              type="text"
                              className="input-signup"
                              value={this.props.xrpAddress}
                              readOnly={true}
                            />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row}>
                        <Form.Label column sm="4" className="label-modal">Destination Tag:</Form.Label>
                        <Col sm="8">
                            <FormControl
                              type="text"
                              className="input-signup"
                              value={this.props.row.address}
                              readOnly={true}
                            />
                        </Col>
                      </Form.Group>
                    </>
                    :
                    <Form.Group as={Row}>
                      <Form.Label column sm="4" className="label-modal">Address:</Form.Label>
                      <Col sm="8">
                        <FormControl
                            type="text"
                            className="input-signup"
                            value={this.props.row.address}
                            readOnly={true}
                          />
                      </Col>
                    </Form.Group>
                  }
                  {/* <Form.Group as={Row}>
                    <Form.Label column sm="3" className="label-modal">Address:</Form.Label>
                    <Col sm="9">
                      {
                        (this.props.walletsinformation.coin == 'xrp')
                        ?<FormControl
                          type="text"
                          className="input-signup"
                          value={this.props.xrpAddress+':dt='+this.props.row.address}
                          readOnly={true}
                        />
                        :<FormControl
                          type="text"
                          className="input-signup"
                          value={this.props.row.address}
                          readOnly={true}
                        />
                      }
                    </Col>
                  </Form.Group> */}
                  {
                    this.props.walletsinformation.coin === 'usdt' && 
                    <Form.Group as={Row}>
                      <Form.Label column sm="4" className="label-modal">Network:</Form.Label>
                      <Col sm="8">
                        <FormControl
                          className="input-signup"
                          value={symbol}
                          readOnly={true}
                          type="text"
                        />
                      </Col>
                    </Form.Group>
                  }
                  <Form.Group as={Row}>
                    <Form.Label column sm="4" className="label-modal">Label:</Form.Label>
                    <Col sm="8">
                      <FormControl
                        type="text"
                        className="input-signup"
                        value={this.props.row.label}
                        readOnly={true}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm="4" className="label-modal">Created date:</Form.Label>
                    <Col sm="8">
                      <FormControl
                        type="text"
                        className="input-signup"
                        value={this.props.row.created_date}
                        readOnly={true}
                      />
                    </Col>
                  </Form.Group>
                </div>
              </div>
            </div>

            {/* <div className="container-qr-code">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="qr-style-container-logo">
                  <QRCode
                    bgColor="#242424"
                    fgColor="#F2F7FF"
                    ecLevel="M"
                    style={{ width: 150 }}
                    value={this.props.row.address}
                    logoWidth={70}
                    logoOpacity={0.6}
                    logoImage={require("../../../CryptoIcons/" + this.props.walletsinformation.coin + ".svg")}
                    qrStyle={"dots"}
                  />
                </div>
              </div>
            </div> */}
            {/* <div className="container-qr-code">
              <div style={{ padding: 30 }}>
                <Form.Group as={Row}>
                  <Form.Label column sm="3" className="label-modal">Address:</Form.Label>
                  <Col sm="9">
                    <p style={{ color: "#BCC3D1", fontSize: 15, marginBottom: 0 }}>{this.props.row.address}</p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="3" className="label-modal">Label:</Form.Label>
                  <Col sm="9">
                    <p style={{ color: "#BCC3D1", fontSize: 15, marginBottom: 0 }}>{this.props.row.label}</p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="3" className="label-modal">Created date:</Form.Label>
                  <Col sm="9">
                    <p style={{ color: "#BCC3D1", fontSize: 15, marginBottom: 0 }}>{this.props.row.created_date}</p>
                  </Col>
                </Form.Group>
              </div>
            </div> */}
          </Modal.Body>
        </Modal>
      </tr>
    );
  }
} export default WalletAddressesCard;
